/** Practice phone & WhatsApp — single source of truth for the whole app */
export const PHONE_E164 = "+919619489446";

/** Shown in UI (footer, CTAs) */
export const PHONE_DISPLAY = "+91-9619489446";

export const WHATSAPP_URL = `https://wa.me/${PHONE_E164.replace("+", "")}`;

export const TEL_URL = `tel:${PHONE_E164}`;

/** Google Maps listing (share / directions): https://maps.app.goo.gl/JuzVZgPA7ov3F2in7 */
export const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/JuzVZgPA7ov3F2in7";

/** Star rating shown on the Google Maps listing — update if the listing changes */
export const GOOGLE_BUSINESS_RATING = "4.9";

/** Same as listing URL; use for “reviews on Google” links */
export const GOOGLE_REVIEWS_URL = GOOGLE_MAPS_URL;

/** Query for embedded map (?q=) — same place as GOOGLE_MAPS_URL */
export const CLINIC_MAP_EMBED_QUERY =
  "Dr Vicky Jain | Plastic Surgeon | Cosmetic Surgeon, 101, Mani Mahal, Mathews Road, petrol pump lane, above Sanghi oxygen, behind charni road, Opera House, Mumbai, Maharashtra 400004";

/** Single-line address for footer & contact */
export const CLINIC_ADDRESS_DISPLAY =
  "101, Mani Mahal, Mathews Road, petrol pump lane, above Sanghi oxygen, behind charni road, Opera House, Mumbai, Maharashtra 400004";

/** Street / locality lines for schema.org (city & PIN separate) */
export const CLINIC_ADDRESS_STREET =
  "101, Mani Mahal, Mathews Road, petrol pump lane, above Sanghi oxygen, behind charni road, Opera House";
